module.exports = __webpack_public_path__ + "img/u2113.fb7dae44.png";